import React from 'react';
import './Elem1Submit.css';

const Elem1Submit = ({ onClick }) => {
  return (
    <div className='submit'>
      <button onClick={onClick} className="submit-container">
        Submit
      </button>    
    </div>
  );
}

export default Elem1Submit;
